import { Api } from '../lib/api/api';
import { toast } from 'react-toastify';
import { ERROR_MESSAGE } from '../lib/constants';

export function cleanPayload(data) {
  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) =>
      Array.isArray(value) ? value.length : !!value || value === false,
    ),
  );
}

export const portInOrderList = (token, data, paginationOptions) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);

  return await api.inteliquent.portInOrderList(body, paginationOptions).catch(error => {
    switch (error.statusCode) {
      case '400':
        toast.error('Invalid telephone number entered');
        break;

      case '409':
        const numbers = error.status.split(':')[1];
        toast.error(`Invalid Number Submitted ${numbers}`);
        break;

      default:
        toast.error(error?.response?.data ?? 'Error Fetching Porting Orders');
        break;
    }

    throw error;
  });
};

export const getPortInAvailability = (token, data) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);
  return await api.inteliquent.getPortInAvailability(body).catch(error => {
    switch (error.statusCode) {
      case '400':
        toast.error(`Invalid Format Only Numbers Allowded`);
        break;

      case '409':
        const numbers = error.status.split(':')[1];
        toast.error(`Invalid Number Submitted ${numbers}`);
        break;

      default:
        toast.error(error?.response?.data ?? 'Error Port in Availability Check Failed');
        break;
    }

    throw error;
  });
};

export const getOrderDetail = (token, data) => async () => {
  const api = new Api(token);
  return await api.inteliquent.getOrderDetail({ orderId: data }).catch(error => {
    switch (error.statusCode) {
      default:
        toast.error(error?.response?.data ?? 'Error Fetching Order Details');
        break;
    }

    throw error;
  });
};

export const createPortInOrder = (token, data, notes, files) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);

  try {
    return await api.inteliquent.createPortInOrder(body, notes, files);
  } catch (error) {
    toast.error(`Please fill the form carefully`);
    return false;
  }
};

export const updatePortInOrder = (token, data, note, files) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);
  return await api.inteliquent.updatePortInOrder(body, note, files).catch(error => {
    switch (error.statusCode) {
      case '410':
        if (error.status.includes('Cannot update Desired Due Date because one')) {
          toast.info('Cannot update Desired Due Date because one or more numbers on the order has a port date within 2 days. Please submit the new Desired Due Date in the Notes section, but do not change the date field.');
          break;
        }
        toast.info(error?.response?.data ?? error.status ?? 'Order does not exist On server');
        break;

      case '418':
        toast.error(
          error?.response?.data ?? error.status ?? 'Character limit is exceeded in Location',
        );
        break;

      default:
        toast.error(error?.response?.data ?? 'Error Updating Port in Order');
        break;
    }

    throw error;
  });
};

export const activatePortInOrder = (token, data) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);
  return await api.inteliquent.activatePortInOrder(body).catch(error => {
    switch (error.statusCode) {
      default:
        toast.error(error?.response?.data ?? 'Error Activating Port in Order');
        break;
    }

    throw error;
  });
};

export const cancelPendingOrder = (token, data) => async () => {
  const api = new Api(token);
  const body = cleanPayload(data);
  return await api.inteliquent.cancelPendingOrder(body).catch(error => {
    switch (error.statusCode) {
      default:
        toast.error(error?.response?.data ?? 'Error Cancelling Port in Order');
        break;
    }

    throw error;
  });
};

export const getOrderDocument = (token, data) => async () => {
  const api = new Api(token);
  return await api.inteliquent.getOrderDocument({ orderId: data }).catch(error => {
    switch (error.statusCode) {
      default:
        toast.error(error?.response?.data ?? 'Error Fetching Order Documents');
        break;
    }

    throw error;
  });
};

export const getTrunkGroupList = (token) => async (dispatch) => {
  dispatch({
    type: 'GET_TRUNK_GROUP_LIST',
  });
  const api = new Api(token);
  const resp = await api.inteliquent.getTrunkGroupList().catch(error => {
    switch (error.statusCode) {
      default:
        dispatch({
          type: 'GET_TRUNK_GROUP_LIST_ERROR',
        });
        toast.error(error?.response?.data ?? 'Error Fetching Trunk Group List');
        break;
    }
    return error
  });
  dispatch({
    type: 'GET_TRUNK_GROUP_LIST_SUCCESS',
    data: resp
  });
  return resp
};
